<div *ngIf="isVisible" class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="onModalClick($event)">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="header-spacer"></div>
        <button class="close-button" (click)="onClose()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="modal-body" *ngIf="employee">
      <!-- Profile Content - Use employee data directly -->
      <div class="profile-content">
        <!-- Profile Section -->
        <div class="profile-section">
          <div class="profile-photo">
            <div class="photo-container">
              <div class="photo-placeholder" *ngIf="!employee.picture_url">
                {{ getEmployeeInitials(employee.first_name, employee.last_name) }}
              </div>
              <img *ngIf="employee.picture_url" [src]="employee.picture_url" [alt]="getEmployeeFullName(employee)" class="photo-image">
            </div>
          </div>
          
          <div class="employee-info">
            <h2 class="employee-name">{{ getEmployeeFullName(employee) }}</h2>
            
            <div class="employee-details">
              <span class="employee-id">{{ getEmployeeId(employee) }}</span>
              <div class="separator"></div>
              <span class="employee-role">{{ employee.designation }}</span>
            </div>
            
            <div class="status-badge" [ngClass]="employee.emp_status ? 'status-active' : 'status-inactive'">
              <span>{{ employee.emp_status ? 'Active' : 'Inactive' }}</span>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <div class="divider"></div>

        <!-- Information Sections -->
        <div class="info-sections">
          <!-- Contact Info -->
          <div class="info-section contact-section">
            <h3 class="section-title">Contact info</h3>
            <div class="section-content">
              <div class="info-item">
                <span class="info-value">{{ employee.email || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <span class="info-value">{{ formatPhoneNumber(employee.phone_number || '') }}</span>
              </div>
            </div>
          </div>

          <!-- Vertical Separator -->
          <div class="vertical-separator"></div>

          <!-- Location -->
          <div class="info-section location-section">
            <h3 class="section-title">Location</h3>
            <div class="section-content">
              <div class="info-item">
                <span class="info-value">{{ getLocationDisplay(employee.branch || '') }}</span>
              </div>
            </div>
          </div>

          <!-- Vertical Separator -->
          <div class="vertical-separator"></div>

          <!-- Start Date -->
          <div class="info-section date-section">
            <h3 class="section-title">Start date</h3>
            <div class="section-content">
              <div class="info-item">
                <span class="info-value">{{ formatDate(employee.start_date || 'MMM dd, yyyy') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
